<div class="enable-credit-card--wrapper">
<input type="checkbox" class="enable-credit-card" on:click={loadCreditCardElem} bind:checked={showCreditCardInput} />
  Add Payment Info
</div>
<div id="payment-form" style="display: none;">
  <div class="form-row">
    <label for="card-element">
      Credit or debit card
    </label>
    <div id="card-element">
      <!-- A Stripe Element will be inserted here. -->
    </div>

    <!-- Used to display form errors. -->
    <div id="card-errors" role="alert"></div>
  </div>
</div>

<script>
// Create a Stripe client.
export let stripe = Stripe('pk_test_pASR7rKTAP8clXFtndcxW3Il00Z45oDb7X');
let showCreditCardInput = false
let card
// Create an instance of Elements.
let elements = stripe.elements();

var style = {
  base: {
    color: '#32325d',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};

export async function getCardToken() {
  try {
      if (!showCreditCardInput) return undefined
      const result = await stripe.createToken(card)
      if (result.error) {
          throw result.error
      } else {
          return result.token.id
      }
  } catch (e) {
      // do not show message as stripe displays it
      throw { message: e.message }
  }
}
let cardCreated = false
// Create an instance of the card Element.
  function loadCreditCardElem() {
    if (!showCreditCardInput)
      document.querySelector("#payment-form").style.display = "inline-block"
    else
      document.querySelector("#payment-form").style.display = "none"
    if (!showCreditCardInput && !cardCreated) {
      setTimeout(() => {
        card = elements.create('card', {style: style});
        cardCreated = true
        // Add an instance of the card Element into the `card-element` <div>.
        card.mount('#card-element');
        
        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function(event) {
          var displayError = document.getElementById('card-errors');
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = '';
          }
        });
      }, 300)
    }
  }
  // loadCreditCardElem()
</script>
<style>

.enable-credit-card--wrapper {
  display: inline-block;
  padding: 0.5rem;
}

.enable-credit-card {
  display: inline-block;
  width: 20%;
}
#payment-form {
    display: block;
    width: 90%;
    margin: 1rem;
    padding: 1rem;
}

#card-element {
    padding: 2.2rem;
}

.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>